import barba from '@barba/core';
import aos from './utils/aos'
// import queryCurrentPage from './graphql/get-current-page.js';

const loadingScreen = document.querySelector('#loadingScreen');


// function fetchCurrentPage() {
// 	fetch('/graphql', {
// 		method: 'POST',
// 		headers: {
// 			'Content-Type': 'application/json',
// 		},
// 		body: JSON.stringify({
// 			query: queryCurrentPage
// 		}),
// 	})
// 	.then((res) => res.json())
// 	.then((result) => {
// 		console.log('result: ', result)
// 	})
// }

barba.hooks.beforeEnter(({ next }) => {
	aos(next.container)
	window.scrollTo(0,0)



	const pageId = next.container.dataset.pageId;
	const breadcrumbs = next.container.dataset.breadcrumbs;

	const pageData = {
		pageId: pageId,
		breadcrumbs: breadcrumbs
	}
	
	const event = new CustomEvent('page-load', { detail: pageData });

	window.dispatchEvent(event);
})

barba.hooks.afterEnter(({ next }) => {
	loadingScreen.classList.add('hide');
})

barba.hooks.beforeLeave(({ next }) => {
	loadingScreen.classList.remove('hide');
})

// import all transitions in the barba transitions folder
const transitions = []
const t = require.context('./transitions/', false, /\.js$/)
t.keys().forEach(key => transitions.push(t(key).default))

// import all views in the barba views folder
const views = []
const v = require.context('./views/', false, /\.js$/)
v.keys().forEach(key => views.push(v(key).default))

// initialise Barba.js
barba.init({
	transitions,
	views,
	timeout: 5000,
	debug: true
})
